import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotService } from '../shared/Forgot.Service';
import { UserId } from '../shared/userid.model';
import * as textMask from "vanilla-text-mask/dist/vanillaTextMask.js";
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-identity-mgt-eb-broker',
  templateUrl: './identity-mgt-eb-broker.component.html',
  styleUrls: ['./identity-mgt-eb-broker.component.scss']
})
export class IdentityMgtEbBrokerComponent implements OnInit, AfterViewInit, OnDestroy {
  public type = '';
  public selected = '';
  public lastname = '';
  public govid = '';
  public pasteData = '';
  public pasteInd = 'N';
  public userId: string;
  public pwd: string;
  public showPlaceholder: boolean;
  error: boolean;
  message: any;
  public resp: any;
  public showId = false;
  public showpwd = false;
  public forgot: any;
  public isLoading = false;
  public validate = true;
  public formErrorFields: any = {
    govid: false,
    govidVal: false,
    option: false,
    lastname: false
  };

  constructor(private router: Router, private forgotService: ForgotService, private appInsightsService: AppInsightsService) { }
  
  ssnmask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // 000-00-0000
  maskedInputController;

  @ViewChild("ssn") public ssn:ElementRef;
  @ViewChild("last") public last: ElementRef;
  @ViewChild("option") public option: ElementRef;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maskedInputController = textMask.maskInput({
        inputElement: this.ssn.nativeElement,
        mask: this.ssnmask,
        guide : false
      });
    });
  }
  ngOnDestroy() {
    this.maskedInputController.destroy();
  }
  
  focusOnInput() {
  	let setError = false;
    if (!!this.formErrorFields.option) {
      setError = true;
      window.scroll(0,0);
      setTimeout(() => this.option.nativeElement.focus(), 0);
      setTimeout(() => this.option.nativeElement.select(), 0);
      window.scrollTo(0,this.option.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formErrorFields.govid || !!this.formErrorFields.govidVal) {
      setError = true;
      setTimeout(() => this.ssn.nativeElement.focus(), 0);
      setTimeout(() => this.ssn.nativeElement.select(), 0);
      window.scrollTo(0,this.ssn.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formErrorFields.lastname) {
      setError = true;
      setTimeout(() => this.last.nativeElement.focus(), 0);
      setTimeout(() => this.last.nativeElement.select(), 0);
      window.scrollTo(0,this.last.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }
    return setError;
 }

  ngOnInit() {
    window.scroll(0,0);
    this.showPlaceholder = true;
    this.appInsightsService.logEvent("Forgot UI Page - Broker");
    this.forgotService.getUid().subscribe( res => {
      this.userId = res;
      if (this.userId) {
        this.showId = true;
        this.showpwd = false;
      }
    });
    this.forgotService.getType().subscribe( res => {
      this.pwd = res;
      if (this.pwd === 'pwd') {
        this.showpwd = true;
        this.showId = false;
      }
      if (this.pwd === 'both') {
        this.showpwd = true;
        this.showId = true;
      }
    });
  }
  
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }

  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }
  
  toggleForm(event: FocusEvent, model) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
    this.validateForm(model)
  }
  
  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }
  
  isErrorPresent() {
    if (!this.formErrorFields.option && !this.formErrorFields.govid && !this.formErrorFields.govidVal && !this.formErrorFields.lastname) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['selected', 'govid', 'lastname'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
    	isErrPresent = this.validateForm(fields[j]);
		if (isErrPresent) {
			break;
		}   
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }

  validateForm(model) {
    let error = false;
    this.validate = true;
    
    if (model === 'selected') {
      if (this.selected === '' || this.selected === undefined || this.selected === null) {
        this.formErrorFields.option = true;
        error = true;
      } else {
        this.formErrorFields.option = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === 'govid') {
      if (!this.govid || this.govid === undefined) {
        this.formErrorFields.govid = true;
        this.formErrorFields.govidVal = false;
        error = true;
      } else if (this.govid !== '' && this.govid.replace(/[- ()]/g, '').length !== 9) {
        this.formErrorFields.govid = false;
        this.formErrorFields.govidVal = true;
        error = true;
      } else {
        this.formErrorFields.govid = false;
        this.formErrorFields.govidVal = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
    
    if (model === 'lastname') {
      if (!this.lastname || this.lastname === undefined) {
        this.formErrorFields.lastname = true;
        error = true;
      } else {
        this.formErrorFields.lastname = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
    
    console.log(this.formErrorFields);
    if (!!this.selected && !!this.govid && !!this.lastname && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }
  
  emptyModelValues() {
    const models = ['selected', 'govid', 'lastname'];
    for (let j = 0; j < models.length; j++) {
    	this[models[j]] = ''; 
    }
  }

  continue() {
    if (!this.validateAllFields()) {
      setTimeout(() => {
      	window.scroll(0, 0);
        this.error = false;
        this.isLoading = true;
        this.validate = true;
      });
      if (this.pasteData.replace(/[- ()]/g,'') === this.govid.replace(/[- ()]/g,'')) {
        this.pasteInd = 'Y';
      } else {
        this.pasteInd = 'N';
      }
      const user = new UserId();
      user.lastName = this.lastname;
      user.ssn = this.govid.replace(/[- ()]/g,'');
      user.userType = 'eb';
      const bodyString = JSON.stringify(user);
      if (this.selected && this.selected === 'id') {
        this.forgotService.getUserId(bodyString).subscribe( res => {
          this.resp = res;
          if (this.resp) {
            setTimeout(() => {
              this.isLoading = false;
            });
            if (this.resp.status_code !== '200') {
              this.message = this.resp.message;
              this.error = true;
              this.validate = false;
              this.emptyModelValues();
              setTimeout(() => {
			      this.maskedInputController = textMask.maskInput({
			        inputElement: this.ssn.nativeElement,
			        mask: this.ssnmask,
			        guide : false
			      });
			    });
              window.scroll(0,0);
            } else {
              this.forgotService.setQuestions(this.resp.questions);
              this.forgotService.setType('uid');
              this.router.navigate(['/questions']);
              this.error = false;
            }
          }
        });
      }
      if (this.selected && this.selected === 'pass') {
        const userId = user.lastName;
        const userType = user.userType;
        const ssn = user.ssn;
        const pasted = this.pasteInd;
        const json = JSON.stringify({ userId, ssn, userType, pasted });
        this.forgotService.getPassword(json).subscribe( res => {
            this.forgot =  res;
            if (this.forgot) {
              setTimeout(() => {
                this.isLoading = false;
              });
              if (this.forgot.status_code && this.forgot.status_code !== '200') {
                  this.message = this.forgot.message;
                  this.error = true;
                  this.validate = false;
                  this.emptyModelValues();
                  setTimeout(() => {
				      this.maskedInputController = textMask.maskInput({
				        inputElement: this.ssn.nativeElement,
				        mask: this.ssnmask,
				        guide : false
				      });
				    });
                  window.scroll(0,0);
                } else {
                    this.error = false;
                    this.forgotService.setQuestions(this.forgot.questions);
                    this.forgotService.setType('pwd');
                    this.forgotService.setUserType(user.userType);
                    this.router.navigate(['/questions']);
                }
            }
        });
      }
      if (this.selected && this.selected === 'idpass') {
        const userId = user.lastName;
        const userType = user.userType;
        const ssn = user.ssn;
        const pasted = this.pasteInd;
        const both = true;
        const json = JSON.stringify({ userId, ssn, userType, pasted, both });
        this.forgotService.getPassword(json).subscribe( res => {
            this.forgot =  res;
            if (this.forgot) {            
              if (this.forgot.status_code && this.forgot.status_code !== '200') {
                  setTimeout(() => {
	                this.isLoading = false;
	              });
                  this.message = this.forgot.message;
                  this.error = true;
                  this.validate = false;
                  this.emptyModelValues();
                  setTimeout(() => {
				      this.maskedInputController = textMask.maskInput({
				        inputElement: this.ssn.nativeElement,
				        mask: this.ssnmask,
				        guide : false
				      });
				    });
                  window.scroll(0,0);
                } else {
                    this.error = false;
                    this.forgotService.setQuestions(this.forgot.questions);
                    this.forgotService.setType('both');
                    this.forgotService.setUserType(user.userType);
                    this.router.navigate(['/questions']);
                }
            }
        });
      }
    } else {
    	this.focusOnInput();
    }
  }


  back() {
    this.router.navigate(['']);
  }

    paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }
}
